import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ticketMessageApi = createApi({
  reducerPath: "ticketMessageApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "communication/ticket-chat",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;  
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTicketMessages:builder.query({
      query:({ticketId, page = 1, limit = 10, sort = "createdAt" })=>{
        let url = `/${ticketId}`

        // if(ticketId){
        //     url += `/${ticketId}`
        // }

        if(sort){
            url += `?sort=${sort}`
        }

        if (page) {
          url += `&page=${page}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        return{
          url: url,
          method: "GET",
        };
      }
    }),

     createTicketMessage: builder.mutation({
      query: ({ message,
          attachments,
          phone,
          fullname,
          nationalCode,ticketId }) => {

        const payload = {};

        if (fullname != null) payload.fullname = fullname;
        if (message != null) payload.message = message;
        if (attachments != null) payload.attachments = attachments;
        if (phone != null) payload.phone = phone;
        if (nationalCode != null) payload.nationalCode = nationalCode;

        return {
          url: `/${ticketId}`,
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const { useGetTicketMessagesQuery, useCreateTicketMessageMutation } = ticketMessageApi;
